import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { api, eur, dt } from "@/lib/api";
import { Panel } from "@/components/Common";

export const StudioRateScadenza = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/studio/rate-scadenza", { params: { giorni: 30 } }).then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (!d) return null;
  return (
    <Panel title="Rate dei clienti in scadenza nei prossimi 30 giorni" className="mb-6">
      <div data-testid="studio-rate-summary" className="mb-3 flex flex-wrap gap-4 text-sm">
        <span className="flex items-center gap-1.5 text-slate-600"><CalendarClock className="h-4 w-4" />{d.rate.length} rate · <b className="font-mono text-slate-900">{eur(d.totale)}</b></span>
        {d.scaduto > 0 && <span className="font-semibold text-rose-700">di cui già scadute {eur(d.scaduto)}</span>}
      </div>
      {d.rate.length === 0 ? <p data-testid="studio-rate-empty" className="text-sm text-slate-500">Nessuna rata in scadenza nei prossimi 30 giorni.</p> : (
        <div className="overflow-x-auto">
          <table data-testid="studio-rate-table" className="w-full min-w-[640px] text-sm">
            <thead><tr className="border-b border-slate-200 text-left text-xs uppercase tracking-wide text-slate-500">
              <th className="py-2 pr-3">Scadenza</th><th className="pr-3">Azienda</th><th className="pr-3">Cliente</th><th className="pr-3">Fattura</th><th className="pr-3">Rata</th><th className="text-right">Importo</th></tr></thead>
            <tbody>
              {d.rate.map((r) => (
                <tr key={`${r.invoice_id}-${r.rata}`} data-testid={`studio-rata-${r.invoice_id}-${r.rata.split("/")[0]}`} className="border-b border-slate-100">
                  <td className={`py-2 pr-3 font-mono ${r.scaduta ? "font-semibold text-rose-700" : ""}`}>{dt(r.scadenza)}{r.scaduta && " · scaduta"}</td>
                  <td className="pr-3 font-medium">{r.azienda}</td><td className="pr-3">{r.cliente}</td>
                  <td className="pr-3 font-mono">n. {r.numero} del {dt(r.data)}</td><td className="pr-3">{r.rata}</td>
                  <td className="text-right font-mono font-semibold">{eur(r.importo)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  );
};
